const leadPassingBaseI18nKey = 'REAL_ESTATE_AGENT.START.LEAD_PASSING';
export const leadPassingSuccessBaseKey = `${leadPassingBaseI18nKey}.SUCCESS`;
